/**
 * DesktopShell Component
 * Feature: 012-desktop-mobile-shells
 * User Story: US1 - Seamless Shell Adaptation
 *
 * Layout structure for desktop viewport (>= 768px).
 * Includes header, sidebar navigation, main content area, and footer.
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/header/header.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-desktop-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    HeaderComponent,
    SidebarComponent
  ],
  templateUrl: './desktop-shell.component.html',
  styleUrl: './desktop-shell.component.scss'
})
export class DesktopShellComponent {}
